import { gql } from "@apollo/client";

const UPDATE_TOR_COMPONENT_TABLE_C = gql`
    mutation updateToRComponentTableC($componentID: String!, $componentCode: String!, $componentTitle: String!, $gradeReceived: String, $ects: String!, $successfullyCompleted: Boolean){
      updateToRComponentTableC(componentID: $componentID, componentCode: $componentCode, componentTitle: $componentTitle, gradeReceived: $gradeReceived, ects: $ects, successfullyCompleted: $successfullyCompleted) 
  }
`;

export default UPDATE_TOR_COMPONENT_TABLE_C;
